import { render, staticRenderFns } from "./InspectionTestEdit.vue?vue&type=template&id=50c3e364&"
import script from "./InspectionTestEdit.vue?vue&type=script&lang=js&"
export * from "./InspectionTestEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports